import yup from 'utils/yup';

export const initialScheduleFormData = {
  id: '',
  title: '',
  description: '',
  show_address: [] as any,
  street: '',
  city: '',
  state: '',
  country: '',
  zipCode: '',
  event_pid: '',
  start_date: undefined as any,
  end_date: undefined as any,
  start_time: '',
  end_time: '',
  job_id: '' as any,
  timezone: '' as any,
  color: '#EF6C00' as any,
  all_day: [] as any,
  repeat: [] as any,
  publish: false,
  repeat_type: '' as any,
  repeat_start_date: undefined as any,
  repeat_end_date: undefined as any,
  weeks: [] as any,
  user_ids: [] as any,
  group_ids: [] as any,
  update_series: false,
};

export const scheduleFormValidationSchema = yup.object().shape({
  title: yup.string().required(),
  user_ids: yup.array().min(1, { msg: 'Select at least one users' }),
  start_date: yup.string().when('all_day', {
    is: (value: any) => !value.length,
    then: yup.string().required(),
  }),
  end_date: yup.string().when('all_day', {
    is: (value: any) => !value.length,
    then: yup.string().required(),
  }),
  start_time: yup.string().when('all_day', {
    is: (value: any) => !value.length,
    then: yup.string().required(),
  }),
  end_time: yup.string().when('all_day', {
    is: (value: any) => !value.length,
    then: yup.string().required(),
  }),
});
